export const columnsSurveys = [
    {
        field: 'title',
        header: 'modals.news_execution.approval.stores_detail.table.header.survey',
        isMain: true,
    },
    {
        field: 'role',
        header: 'modals.news_execution.project_specs.details.assignment',
        isMain: true,
    },
    {
        field: 'start_date',
        header: 'modals.filters.label.start_date',
        isMain: true,
    },
    {
        field: 'end_date',
        header: 'modals.news_execution.action.tasks.detail.end_date',
        isMain: true,
    },
    {
        field: 'priority',
        header: 'modals.news_execution.action.tasks.detail.priority',
        isMain: true,
    },
    {
        field: 'completion',
        header: 'modals.news_execution.approval.stores_detail.table.header.completion',
        isMain: true,
    },
    {
        field: 'surveyUrl',
        header: 'modals.news_execution.approval.stores_detail.table.header.surveyUrl',
    },
]
